var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.pageConfig))?_c('div',[((_vm.show))?_c('Index',{attrs:{"pageConfig":(_vm.pageConfig),"info":(_vm.info)}}):_c('error-page',{attrs:{"message":(_vm.pageErrorMessage),"exception":(_vm.exception),"isKf":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }